import React from 'react';
import { Button as ButtonAnt } from 'antd';
import styled from 'styled-components';

type ButtonVariant = 'submit' | 'cancel' | 'default' | 'none';

interface CommonButtonProps {
  buttonType?: ButtonVariant;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  children: React.ReactNode;
  className?: string;
  htmlType?: 'button' | 'submit' | 'reset';
  width?: number;
  disabled?: boolean;
}

const StyledButton = styled.div<{
  buttonType: ButtonVariant;
  width?: number;
}>`
  & {
    font-size: 14px;
    font-weight: 600;
    line-height: 22px;
    
  }
  .ant-btn {
    display: flex;
    align-items: center;
    display: flex;
    justify-content: center;
    width: ${(props) => (props.width ? `${props.width}px` : 'auto')};
  }

  ${(props) =>
    props.buttonType === 'submit' &&
    `
    .ant-btn {
      background-color: #1890ff;
      color: white;
      border: none;
    }
  `}
  
  ${(props) =>
    props.buttonType === 'none' &&
    `
    .ant-btn {
      background-color: rgb(34, 32, 30);
      color: #0c3255;
      border: 1px solid #0c3255;
    }
  `}
  
  ${(props) =>
    props.buttonType === 'cancel' &&
    `
    .ant-btn {
      background-color: #DB2C1F;
      color: white;
      border: none;
    }
  `}
  
  ${(props) =>
    props.buttonType === 'default' &&
    `
    .ant-btn {
      background: #0c3255;
      color: #ffffff;
      border: none;
    }
  `}

  .ant-btn:disabled {
    ${(props) =>
    props.buttonType === 'default' &&
    `
      background: #867956;
      color: #ffffff;
      border: none;
    `}
    ${(props) =>
    props.buttonType === 'cancel' &&
    `
      background: #994e48;
      color: #b3b3b3;
      border: none;
    `}
  }

  .ant-btn:hover {
    opacity: 0.9;
  }

  &.btn-right {
    float: right;
  }
`;

const Button: React.FC<CommonButtonProps> = ({
  buttonType = 'default',
  onClick,
  children,
  className,
  htmlType = 'button',
  width,
  disabled,
  ...props
}) => {
  return (
    <StyledButton buttonType={buttonType} width={width}>
      <ButtonAnt
        onClick={onClick}
        className={className}
        htmlType={htmlType}
        disabled={disabled}
        {...props}
      >
        {children}
      </ButtonAnt>
    </StyledButton>
  );
};

export default Button;
